module.exports = __webpack_public_path__ + "img/toilet_family1.47031995.png";